<script>
import DocumentGrid from '../Document/DocumentGrid'
import DocumentUpload from '../Document/DocumentUpload'
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { api } from "src/plugins/axios";
import { notify } from "src/plugins/notify";
import { formatDateTime } from "src/utils";
import { lkKey } from "src/utils";

const moment = require("moment");

export default {
  components: {
    DocumentGrid,
    DocumentUpload
  },
  data() {
    return {
      moment: moment,
      maximized: false,
      cancelling: false
    };
  },
  async created() {
    var vm = this;
    _.map(vm.orderDetails.items, (i, index) => {
      vm.updateItemFromType({
        itemIndex: index,
        orderType: i.orderType,
        detail: true
      });
    });

    await vm.loadOrderDetailItems();
  },
  computed: {
    ...mapGetters("orders", ["orderTypeOptions"]),
    ...mapGetters(["stateOptions"]),
    ...mapState("orders", {
      orderDetails: s => s.orderDetails,
      loading: s => s.orderDetails.loading,
      detailsModalOpenState: s => s.detailsModalOpenState
    }),
    ...mapState({
      user: s => s.auth.user,
      documentUploadState: s => s.documents.uploadModal.open
    }),
    orderTotal() {
      let vm = this;
      return _.sumBy(vm.orderDetails.items, o => {
        return parseFloat(vm.itemPrice(o));
      }).toFixed(2);
    },
    orderTotalItems() {
      let vm = this;
      return _.sumBy(vm.orderDetails.items, o => {
        return o.quantity || 0;
      });
    },
    status() {
      let vm = this,
        status = this.orderDetails.ORDER_STATUS || "Loading";
      return;
    },
    orderPaidBy() {
      let vm = this;
      return `${vm.orderDetails.ORDER.USER.USER_FIRST_NAME} ${
        vm.orderDetails.ORDER.USER.USER_LAST_NAME
      }`;
    },
    paidByInitials() {
      let vm = this;
      return `${vm.orderDetails.ORDER.USER.USER_FIRST_NAME[0].toUpperCase()}${vm.orderDetails.ORDER.USER.USER_LAST_NAME[0].toUpperCase()}`;
    },
    status() {
      return this.statusLabel();
    }
  },
  methods: {
    ...mapMutations("orders", ["detailsModalOpen", "updateItemFromType"]),
    ...mapMutations({
      openUpload: "documents/openUpload"
    }),
    ...mapActions("orders", [
      "fetchOrderTypes",
      "loadOrderDetailItems",
      "updateOrderStatus",
      'update',
      "setPaymentModalOrder"
    ]),
    async onPayNow(){
      let vm = this
      // Set order
      await vm.setPaymentModalOrder({ ORDER_ID: vm.orderDetails.ORDER.ORDER_ID, open: true })
    },
    itemPrice(item) {
      return parseFloat(item.price * item.quantity).toFixed(2);
    },
    print() {
      window.print();
    },
    date(d, f) {
      return formatDateTime(d, f);
    },
    toggleMaximized() {
      this.maximized = !this.maximized;
    },
    statusLabel() {
      let vm = this;
      let status = vm.orderDetails.ORDER.LK_ORDER_STATUS;
      return lkKey("LK_ORDER_STATUS_ID", status);
    },
    upload() {
      this.openUpload()
    },
    updateMethod(options = {}){
      options.vm = this
      this.update(options)
    }
  }
};
</script>

<template>
  <q-modal
    id="orderDetailsModal"
    class="sl-modal"
    v-model="detailsModalOpenState"
    :no-esc-dismiss="true"
    :no-backdrop-dismiss="true"
    :maximized="maximized"
    :content-css="{width: '1000px', height: '800px'}"
  >
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-toolbar-title>
          <q-icon name="attach_money"/>
          Order {{orderDetails.ORDER.ORDER_ID}} Details
          <div
            style="display:inline-block;margin-left: 10px;border-radius:30px"
            class="label outline"
            :class="{
                            'blue': status == 'Placed',
                            'green' : status =='Completed' || status =='Fulfilled',
                            'red' : status =='Cancelled' || status == 'Unpaid'
                        }"
          >{{statusLabel()}}</div>
        </q-toolbar-title>
        <q-icon
          outline
          name="print"
          @click.native="print()"
          label="Print"
          size="22px"
          style="margin-right: 7px"
          v-if="!loading"
        />
        <q-btn-dropdown class="approval-history" icon="more_vert" v-if="!loading && $p(['ADMIN','MANAGER'],'or')">
          <q-list>
              <q-item link v-if="orderDetails.ORDER.LK_ORDER_STATUS != 3" @click.native="updateMethod({ LK_ORDER_STATUS: 3 })" v-close-overlay>
                  <q-item-side icon="not_interested" color="red" />
                  <q-item-main>
                      <q-item-tile label>
                          Cancel Order
                      </q-item-tile>
                  </q-item-main>
              </q-item>
              <q-item link v-close-overlay>
                  <q-item-side icon="redo" color="primary" size="25px" />
                  <q-item-main>
                      <q-item-tile label>
                          Refund Order
                      </q-item-tile>
                  </q-item-main>
              </q-item>
          </q-list>
        </q-btn-dropdown>
        <q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none"/>
        <q-icon @click.native="detailsModalOpen(false)" name="clear"/>
      </q-toolbar>

      <div class="sl-row header-row">
        <div class="sl-col-4">
            <label>Order Number</label>
            #{{orderDetails.ORDER.ORDER_ID}}
        </div>
        <div class="sl-col-4">
          <label>Date Placed</label>
          {{ moment(orderDetails.ORDER.DATE_CREATED).format("MMMM Do, YYYY h:mm A") }}
        </div>
        <div class="sl-col-4">
          <label>Placed By</label>
          <div class="label green round">
            <span>{{paidByInitials}}</span>
          </div>
          {{orderPaidBy}}
        </div>
      </div>
      <div class="order-details-wrapper">
        <div class="sl-row" style="font-size: 15px;margin-top:5px;margin-bottom:0">
          <div class="sl-col-4">            
            <h6 v-if="orderDetails.ORDER.PAYMENT && orderDetails.ORDER.PAYMENT.PAYMENT_METHOD" style="margin-bottom:10px"><q-icon name="credit_card" color="primary" /> Payment Method</h6>
            <div v-if="orderDetails.ORDER.PAYMENT">
              <b>{{(orderDetails.ORDER.PAYMENT.PAYMENT_METHOD) ? orderDetails.ORDER.PAYMENT.PAYMENT_METHOD.PAYMENT_METHOD_USERFRIENDLY : ''}}</b>
            </div>
            <div v-if="orderDetails.ORDER.OVERRIDE_USER_ID" style="margin-top:10px">
              <p><b>Placed By</b>: {{orderDetails.ORDER.OVERRIDE_USER.USER_FIRST_NAME}} {{orderDetails.ORDER.OVERRIDE_USER.USER_LAST_NAME}}</p>
            </div>
          </div>
          <div class="sl-col-4">
            <h6 style="margin-bottom:10px"><q-icon name="location_on" color="primary" /> Billing Address</h6>
            <div>{{orderDetails.ORDER.BILLING_ADDRESS.ADDRESS_1}}</div>
            <span v-if="orderDetails.ORDER.BILLING_ADDRESS.CITY">{{orderDetails.ORDER.BILLING_ADDRESS.CITY}}, </span>
            <span v-if="orderDetails.ORDER.BILLING_ADDRESS.STATE">{{orderDetails.ORDER.BILLING_ADDRESS.STATE.STATE_NAME}}, </span>
            <span v-if="orderDetails.ORDER.BILLING_ADDRESS.COUNTRY">{{orderDetails.ORDER.BILLING_ADDRESS.COUNTRY}}, </span>
            <span>{{orderDetails.ORDER.BILLING_ADDRESS.ZIP_CODE}}</span>
          </div>
          <div class="sl-col-4">
            <h6 style="margin-bottom:10px"><q-icon name="local_shipping" color="primary" /> Mailing Address</h6>
            <div>{{orderDetails.ORDER.MAILING_ADDRESS.ADDRESS_1}}</div>
            <span v-if="orderDetails.ORDER.MAILING_ADDRESS.CITY">{{orderDetails.ORDER.MAILING_ADDRESS.CITY}}, </span>
            <span v-if="orderDetails.ORDER.MAILING_ADDRESS.STATE">{{orderDetails.ORDER.MAILING_ADDRESS.STATE.STATE_NAME}}, </span>
            <span v-if="orderDetails.ORDER.MAILING_ADDRESS.COUNTRY">{{orderDetails.ORDER.MAILING_ADDRESS.COUNTRY}}, </span>
            <span>{{orderDetails.ORDER.MAILING_ADDRESS.ZIP_CODE}}</span>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="sl-row" style="margin-top:30px">
          <div class="sl-col-12 section-header" style="margin-top:0">
            <h6 class="inline"><q-icon name="fa fa-shopping-cart" color="primary" size="25px" /> {{orderDetails.items.length}} Item{{(orderDetails.items.length > 1 ? "s" : "")}} Purchased</h6>
          </div>
        </div>
        <div class="row">
          <div class="sl-table sl-col-12" style="width:100%;">
            <div class="sl-row th">
              <div class="sl-col-6">Item Description</div>
              <div class="sl-col-2">Quantity</div>
              <div class="sl-col-2">Price</div>
              <div class="sl-col-2 text-right">Total</div>
            </div>
            <div class="sl-row tr" v-for="(item,i) in orderDetails.items" :key="i">
              <div class="sl-col-6 text-weight-bolder">
                {{item.description}}
              </div>
              <div class="sl-col-2">
                x{{item.quantity}}
              </div>
              <div class="sl-col-2 price">
                ${{item.price}}
              </div>
              <div class="sl-col-2 text-weight-bolder text-right">
                ${{itemPrice(item)}}                
              </div>
            </div>
          </div>          
        </div>
        <div class="meta text-right">
          <div class="display-inline total">
            <span class="text-label">Total:</span>
            <b class="order-total">
              ${{orderDetails.ORDER.TOTAL}}
            </b>
          </div>
        </div>
        <div class="sl-row">
          <!-- <div class="sl-col-6 no-padding order-details-documents">
            <div class="section-header">
              <h5 class="inline">Documents</h5>
            </div>
            <document-grid :entityItemId="orderDetails.ORDER.ORDER_ID" :deletable="true"/>
            <document-upload v-if="documentUploadState" :hideEntity="true" :entityItemId="orderDetails.ORDER.ORDER_ID"/>
          </div> -->
          <div class="sl-col-6 order-details-notes">
            <div class="section-header">
              <h5 class="inline"><q-icon name="notes" color="primary" /> Notes</h5>
            </div>
            <q-input
              inverted-light
              color="grey-12"
              v-model="orderDetails.ORDER.NOTES"
              type="textarea" rows="5"/>
          </div>
          <div class="sl-col-6" v-if="orderDetails.ORDER.CLASS_ID">
            <div class="section-header">
              <h5 class="inline"><q-icon name="book" color="primary" /> Class</h5>
            </div>
            <div><b>Class ID</b>: {{orderDetails.ORDER.CLASS_ID}}</div>
            <div><b>Class Date</b>: {{moment(orderDetails.ORDER.CLASS.CLASS_START_DATE).format("MMMM Do, YYYY h:mm A")}}</div>
            <div><b>Affiliate</b>: {{orderDetails.ORDER.CLASS.AFFILIATE.AFFILIATE_NAME}}</div>
          </div>
        </div>
      </div>

      <q-toolbar slot="footer" class="sl-footer">
        <q-toolbar-title></q-toolbar-title>
        <!-- <q-btn
          label="Upload"
          icon="cloud_upload"
          color="green"
          outline    
          v-if="$p(['ADMIN','MANAGER'], 'or')"      
          @click="upload()">
          </q-btn>&nbsp; -->
        <q-btn style="margin-right:3px;" color="primary" 
          v-if="orderDetails.ORDER.LK_ORDER_STATUS != 2 
                && orderDetails.ORDER.LK_ORDER_STATUS != 3 
                && orderDetails.ORDER.LK_ORDER_STATUS != 5 
                && $p(['ADMIN','MANAGER'],'or')" @click="updateMethod({ LK_ORDER_STATUS: 2 })" label="Complete Order"/>
        <q-btn style="margin-right:3px;" color="primary" 
          v-if=" orderDetails.ORDER.LK_ORDER_STATUS == 5"
          @click="onPayNow()" label="Pay Now"/>
        <q-btn style="margin-right:3px;" color="green" v-if="$p(['ADMIN','MANAGER'],'or')" @click="updateMethod()" label="Save"/>
        <q-btn outline color="faded" @click="detailsModalOpen(false)" label="Close"/>
      </q-toolbar>
    </q-modal-layout>
    <q-inner-loading :visible="loading">
      <q-spinner-puff color="primary" size="70"></q-spinner-puff>
      <span v-show="loading">Retrieving Order..</span>
      <span v-show="cancelling">Cancelling..</span>
    </q-inner-loading>
  </q-modal>
</template>

<style lang="stylus">
@import '~variables';

#orderDetailsModal {
  .section-header {
    margin-top: 30px;
    margin-bottom: 10px;

    h5 {
      margin-top: 0;
    }

    .label {
      &.small {
        margin: 0 7px 7px 0;
      }
    }
  }

  .modal-content {
    max-height: 100%;
  }
  .sl-table{
    border-radius: 8px 8px 0 8px  
  }
  .sl-footer {
    .q-btn {
      margin-left: 5px;
    }
  }

  .order-details-wrapper {
    margin: 25px 20px;
  }

  .pull-right {
    float: right;
  }

  .header-row {
    background: #eee;
    border-bottom: 1px solid border-color;

    .sl-col-4 {
      padding: 40px 30px;
      border-right: 1px solid border-color;
      position: relative;
      font-weight: 600;
      font-size: 17px;
      height: 130px;

      .q-icon {
        top: 30%;
        font-size: 40px;
        position: absolute;
        right: 20px;
        color: #b9b9b9;
      }

      label {
        font-weight: 400;
        font-size: 10px;
        letter-spacing: 1px;
        text-transform: uppercase;
        display: block;
        margin: 0 0 5px;
      }
    }

    .label {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
    }
  }

  .meta {
    margin: 0 0 60px;

    .pull-left {
      float: left;
    }

    .text-label {
      font-weight: 600;
      font-size: 13px;
      letter-spacing: 1px;
      text-transform: uppercase;
      display: inline-block;
      margin: 0 0 5px;
    }
    .total{
      float: right;
      padding: 13px 29px;
      background: #dadada;
      border-radius: 0 0 7px 7px;
    }
  }

  .order-total {
    color: #000;

    i {
      font-size: 13px;
      color: #bbb;
    }
  }
}

@media print {
  @page {
    margin: 20px;
  }

  body {
    -webkit-print-color-adjust: exact !important;
    overflow visible !important
  }

  .order-details-wrapper {
    margin: 20px !important;
  }

  .q-if-disabled {
    opacity: 1 !important;
  }

  .q-input-target {
    color: #000 !important;
  }
  .q-modal-layout-content,.scroll{
    overflow: visible !important
  }
  .sl-modal {
    display: block;
    width: 8in;
    height: 100%;
    overflow: visible  !important;

    .modal-content {
      box-shadow: none;
      overflow: visible  !important;
      min-height: 100%;
    }
    .q-modal-layout-content,.scroll{
      overflow: visible !important
    }

    .sl-table {
      .q-if-label {
        display: none;
      }

      .q-if-has-label .q-if-inner {
        padding-top: 0;
      }

      .material-icons {
        font-size: 25px !important;
      }
    }

    .header-row {
      position: relative;

      .sl-col-4 {
        display: inline-block;
        padding: 30px 15px !important;
        height: 100px !important;
        font-size: 13px !important;

        .label {
          display: none !important;
        }
      }
    }

    .sl-col-1 {
      width: 8.33%;
    }

    .sl-col-2 {
      width: 16.66%;
    }

    .sl-col-3 {
      width: 25%;
    }

    .sl-col-4 {
      width: 33.33%;
    }

    .sl-col-5 {
      width: 39.66%;
    }

    .sl-col-6 {
      width: 50%;
    }

    .sl-col-7 {
      width: 58.33%;
    }

    .sl-col-8 {
      width: 66.66%;
    }

    .sl-col-9 {
      width: 75%;
    }

    .sl-col-10 {
      width: 83.33%;
    }

    .sl-col-11 {
      width: 91.66%;
    }

    .sl-col-12 {
      width: 100%;
    }
    [class^="sl-col"]{
      display: inline-block;
    }
  }

  .order-details-notes {
    width: 100% !important;
  }

  #q-app, .q-toolbar i, .order-details-documents {
    display: none;
  }

  .q-layout-footer {
    .q-toolbar {
      display: none;
    }
  }
}
</style>
